export default "__VITE_ASSET__DGjFG8ox__"